<div class="ms" (click)="$event.stopPropagation()">
  <button #trigger type="button" class="ms__trigger" [disabled]="disabled" [attr.aria-expanded]="open" [attr.aria-labelledby]="triggerLabelledBy"
          (click)="toggleOpen($event)">
    <span class="ms__summary" [id]="summaryId">{{ summary }}</span>
    <svg class="chev" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  </button>

  <div #panel class="ms__panel" [class.ms__panel--up]="opensUp" *ngIf="open" [attr.role]="sheet ? 'group' : null"
       [attr.aria-labelledby]="sheet ? titleId : null" (keydown)="leaveOnTab($event)">
    <div *ngIf="sheet" class="ms__head">
      <span [id]="titleId">{{ sheetTitle }}</span>
      <button #done type="button" (click)="finish($event)">Done</button>
    </div>
    <button type="button" class="ms__opt" [disabled]="allDisabled" [attr.aria-pressed]="isAllActive" (click)="selectAll($event)">
      <span class="ms__check" [class.on]="isAllActive" aria-hidden="true">&#10003;</span><span class="ms__txt">{{ allLabel }}<span *ngIf="allHint" class="ms__hint">{{ allHint }}</span></span>
    </button>
    <div class="ms__divider"></div>
    <button type="button" class="ms__opt" [class.ms__opt--stale]="row.option.isStale" *ngFor="let row of rows; trackBy: trackByValue"
            [attr.aria-pressed]="row.isChecked" (click)="toggle(row.option.value, $event)">
      <span class="ms__check" [class.on]="row.isChecked" aria-hidden="true">&#10003;</span>{{ row.option.label }}
    </button>
    <div class="ms__empty" *ngIf="!options.length">No options</div>
  </div>
</div>
